const env = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV

export const LEGACY_DASHBOARD_URL: string =
  env === 'production'
    ? 'https://dashboard.opinary.com'
    : 'https://dashboard-dot-opinary-dev.appspot.com'

export const LEGACY_POLL_LIST_URL: string = `${LEGACY_DASHBOARD_URL}/library/all`
